import React from 'react'
import * as d3 from 'd3'
import 'd3-selection-multi'
const nf = new Intl.NumberFormat('de-CH')

export const showHorizontalTicks = ({
  svgGroup,
  data,
  x,
  y
}: {
  svgGroup: svgGroupType
  data: number[]
  x: [number, number]
  y: (d: number) => number
}) => {
  svgGroup
    .selectAll('line')
    .data(data)
    .join('line')
    .attrs({
      class: (d: number, i: number) => {
        if (i >= data.length - 1) return 'tick first'
        return 'tick'
      },
      x1: x[0],
      x2: x[1],
      y1: y,
      y2: y
    })
}
export const showHorizontalTickText = ({
  svgGroup,
  data,
  text,
  x,
  y
}: {
  svgGroup: svgGroupType
  data: number[]
  text: (a: number) => string
  x: number
  y: (a: number) => number
}) => {
  svgGroup
    .selectAll('text')
    .data(data)
    .join('text')
    .text(text)
    .attrs({
      class: 'tickValues',
      x: x,
      y: y
    })
}
export const showVerticalTicks = ({
  svgGroup,
  data,
  x,
  y
}: {
  svgGroup: svgGroupType
  data: number[]
  x: (a: number) => number
  y: [number, number]
}) => {
  svgGroup
    .selectAll('line')
    .data(data)
    .join('line')
    .attrs({
      class: 'tick',
      x1: x,
      x2: x,
      y1: y[0],
      y2: y[1]
    })
}
export const showVerticalTickText = ({
  svgGroup,
  data,
  text,
  x,
  y
}: {
  svgGroup: svgGroupType
  data: number[]
  text: (a: number) => string
  x: (a: number) => number
  y: number
}) => {
  svgGroup
    .selectAll('text')
    .data(data)
    .join('text')
    .text(text)
    .attrs({
      class: 'tickValues',
      x: x,
      y: y
    })
}
export const showCurrenValue = ({
  svgGroup,
  data,
  x,
  y,
  barWidth,
  prop,
  specialVal
}: {
  svgGroup: svgGroupType
  data: InputDataData[]
  x: d3.ScaleLinear<number, number>
  y: d3.ScaleLogarithmic<number, number>
  barWidth: number
  prop: string
  specialVal?: string | number | undefined
}) => {
  if (data.length <= 0) return

  let last = data.reverse().find(e => e.hasOwnProperty(prop))
  let lastValue = last[prop] > 9999 ? nf.format(last[prop]) : last[prop]
  let xPos = x(last.day)
  let yPos = y.range()[0] - y(+last[prop] + 1)
  if (xPos > +x.range()[1]) {
    xPos = +x.range()[1] - 60
    yPos = 50
  }
  const verticalChange = yPos > y.range()[0] * 0.4 ? -15 : 15

  const horizontalChange = 0

  // if (data[data.length - lastVal][prop] > 0) {
  svgGroup.append('line').attrs({
    x1: xPos - barWidth / 2 + horizontalChange,
    x2: xPos - barWidth / 2,
    y1: yPos + verticalChange,
    y2: yPos + (verticalChange > 0 ? 4 : -4),
    class: 'currentValueLine',
    strokeWidth: 0.25
  })
  svgGroup
    .append('text')
    .attr('class', 'currentValue')
    .text(specialVal ? specialVal : '+' + lastValue)
    .attrs({
      x: xPos + horizontalChange,
      y: yPos + verticalChange + (verticalChange > 0 ? 10 : -3),
      'text-anchor': xPos > +x.range()[1] * 0.6 ? 'end' : 'start',
      fill: '#000'
    })
  // }
}
export const showMovingAverage = ({
  svgGroup,
  data,
  x,
  y
}: {
  svgGroup: svgGroupType
  data: MovingAverageProps[]
  x: (d: MovingAverageProps, i?: number) => number | undefined
  y: (d: MovingAverageProps, i?: number) => number
}) => {
  const line = d3
    .line<MovingAverageProps>()
    .defined(d => !isNaN(y(d)))
    .x(x)
    .y(y)
  svgGroup.append('path').attrs({
    d: line(data),
    fill: 'none',
    stroke: '#000'
  })
}
export const showBars = ({
  svgGroup,
  data,
  x,
  y,
  width,
  height,
  className
}: {
  svgGroup: svgGroupType
  data: InputDataData[]
  x: (a: InputDataData) => number
  y: (a: InputDataData) => number
  width: number
  height: (a: InputDataData) => number
  className: string
}) => {
  if (+width >= 0) {
    svgGroup
      .selectAll('rect')
      .data(data)
      .join('rect')
      .attrs({
        x: x,
        y: y,
        width: width,
        height: height,
        class: className
      })
  }
}
export const calculateMovingAverage = ({
  data,
  prop,
  x
}: {
  data: InputDataData[]
  prop: InputDataDataProps
  x: d3.ScaleLinear<number, number>
}) => {
  const ret: MovingAverageProps[] = data.map((e: InputDataData, i: number) => {
    let ave =
      i < 2 ? e[prop] : (+e[prop] + +data[i - 1][prop] + +data[i - 2][prop]) / 3
    if (ave < 1) ave = 1
    return {
      x: x(e.day - 1),
      y: +ave
    }
  })
  return ret
}
export const generateTicks: (
  domain: number[],
  steps: number
) => { lines: number[]; texts: string[] } = (domain, steps) => {
  const ticks: number[] = d3.range(0, domain[1], steps)
  ticks[ticks.length] = domain[1]
  const text = JSON.parse(JSON.stringify(ticks))
  text.pop()
  text[0] = 'Tage'
  return { lines: ticks, texts: text }
}

export const chunkArray: chunkArrayType = (arrIn, chunkSize) => {
  let arr = JSON.parse(JSON.stringify(arrIn))
  const arrayLength = arr.length
  const tempArr: { [key: string]: any }[][] = []

  let index = 0

  for (index = 0; index < arrayLength; index += chunkSize) {
    const myChunk: { [key: string]: any }[] = arr.slice(
      index,
      index + chunkSize
    )

    tempArr.push(myChunk)
  }

  return tempArr
}
export const chunkArray_SWISS = (
  arrIn: cantonsData[] | InputData[],
  chunkSize: number
) => {
  let arr = JSON.parse(JSON.stringify(arrIn))
  const arrayLength = arr.length
  const tempArr: cantonsData[][] | InputData[][] = []

  let isCountries = arr[0].code === 'CH'
  let ch = undefined
  if (isCountries && chunkSize === 2) {
    ch = arr.shift()
    tempArr.push([ch])
  }
  let index = isCountries ? 1 : 0

  for (index = 0; index < arrayLength; index += chunkSize) {
    const myChunk: cantonsData[] | InputData[] = arr.slice(
      index,
      index + chunkSize
    )

    tempArr.push(myChunk)
  }

  return tempArr
}
export const doublingValue = (day: number, days: number) => {
  return 100 * Math.pow(2, day / days)
}

export const HorizontalTick = ({
  x1,
  x2,
  y,
  text,
  textY
}: {
  x1: number
  x2: number
  y: number
  textY: number
  text: string
}) => {
  return (
    <>
      <line x1={x1} x2={x2} y1={y} y2={y} className='tick' />
      <text className='tickValues' x={x1 + 4} y={textY}>
        {text}
      </text>
    </>
  )
}
export const VerticalTick = ({
  x,
  y1,
  y2,
  text,
  textY
}: {
  y1: number
  y2: number
  x: number
  textY: number
  text: string
}) => {
  return (
    <>
      <line className='tick ' x1={x} x2={x} y1={y1} y2={y2} />
      <text className='tickValues' x={x - 2} y={textY}>
        {text}
      </text>
    </>
  )
}
export const DMarker = ({
  text,
  pos
}: {
  text: string
  pos: [number, number]
}) => {
  return (
    <>
      <circle cx={pos[0]} cy={pos[1]} r={9} className='doublingMarker' />
      {/* <rect
        x={pos[0] - 30}
        y={pos[1] - 11}
        width={52}
        height={22}
        className='doublingMarker'
        rx={11}
      /> */}
      <text
        {...{
          x: pos[0],
          y: pos[1] + 3,
          className: 'doublingVal',
          textAnchor: 'middle'
        }}
      >
        {text}
      </text>
    </>
  )
}
export const KeyEntry = ({
  iconFile,
  text,
  children,
  twoLiner = false,
  nextLine = false,
  bold = false
}: {
  iconFile?: string
  text?: string
  children?: JSX.Element
  twoLiner?: boolean
  nextLine?: boolean
  bold?: boolean
}) => (
  <div
    className={
      'entry' +
      (bold ? ' bo' : '') +
      (twoLiner ? ' tL' : '') +
      (nextLine ? ' nL' : '')
    }
  >
    {iconFile && <img src={require('images/' + iconFile)} />}
    {text && (
      <div className='title'>
        <div className='label'>{text}</div>
      </div>
    )}
    {children && <div className='additional'>{children}</div>}
  </div>
)
export const formatSwissDate = (
  datestring: string | Date,
  format: 'long' | 'short' | 'middle'
) => {
  let months = [
    'Jan.',
    'Feb.',
    'März',
    'Apr.',
    'Mai',
    'Juni',
    'Juli',
    'Aug.',
    'Sept.',
    'Okt.',
    'Nov.',
    'Dez.'
  ]
  if (typeof datestring === 'object') {
    datestring =
      datestring.getDate() +
      '.' +
      (datestring.getMonth() + 1) +
      '.' +
      datestring.getFullYear()
  }

  datestring = datestring.toString()
  let parts = datestring.split('.')

  if (parts.length === 1) parts = datestring.split('/')

  let short =
    +parts[1].trim() +
    (window.innerWidth > 700 || window.innerWidth < 600 ? '.20' : '.')
  let middle = months[+parts[1].trim() - 1]
  let long = months[+parts[1].trim() - 1] + ' 2020'

  let ret = format === 'long' ? long : format === 'middle' ? middle : short

  return (
    parts[0] +
    (format === 'long' ? '. ' : format === 'middle' ? '.' : '.') +
    (format === 'long' && (window.innerWidth > 850 || window.innerWidth < 600)
      ? long
      : format === 'middle' &&
        (window.innerWidth > 850 || window.innerWidth < 650)
      ? middle
      : short)
  )
}
